import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Flame, Plus } from "lucide-react";
import api from "@/lib/api";
import { ChallengeCard } from "@/components/cards";
import { Loader, SectionHeader, EmptyState, Chip, PrimaryButton, PASSION_LABEL } from "@/components/ui-bits";

const PASSIONS = ["photography", "fitness-wellness", "art-creative", "music", "cooking", "writing"];

export default function Challenges() {
  const [params, setParams] = useSearchParams();
  const passion = params.get("passion") || "";
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    const q = new URLSearchParams();
    if (passion) q.set("passion", passion);
    api.get(`/challenges?${q}`).then((r) => setItems(r.data));
  }, [passion]);

  const setPassion = (p) => { const np = new URLSearchParams(params); p ? np.set("passion", p) : np.delete("passion"); setParams(np); };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <SectionHeader eyebrow="Challenges" title="Build the habit. Together."
        subtitle="Recurring challenges that keep you creating and moving with your community."
        action={<PrimaryButton as={Link} to="/create/challenge" data-testid="create-challenge-cta"><Plus className="h-4 w-4" />Create challenge</PrimaryButton>} />

      <div className="flex flex-wrap items-center gap-2 mb-8 overflow-x-auto pb-1">
        <Chip active={!passion} onClick={() => setPassion("")} data-testid="challenges-filter-all">All passions</Chip>
        {PASSIONS.map((p) => <Chip key={p} active={passion === p} onClick={() => setPassion(p)} data-testid={`challenges-filter-${p}`}>{PASSION_LABEL[p]}</Chip>)}
      </div>

      {!items ? <Loader /> : items.length ? (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="challenges-grid">{items.map((c) => <ChallengeCard key={c.id} c={c} />)}</div>
      ) : (
        <EmptyState icon={Flame} title="No challenges yet" hint="Launch a challenge and energize your community."
          action={<PrimaryButton as={Link} to="/create/challenge">Create challenge</PrimaryButton>} />
      )}
    </div>
  );
}
